import { Droppable } from "@hello-pangea/dnd";
import type { Job } from "../../providers/fakerest/dataGenerator/types";
import { JobCard } from "./JobCard";
import { findStageLabel, findStageColor } from "./jobStages";

export const JobColumn = ({
  status,
  jobs,
}: {
  status: Job["status"];
  jobs: Job[];
}) => {
  const totalValue = jobs.reduce((sum, job) => sum + job.estimated_value, 0);
  const formattedTotal = new Intl.NumberFormat("en-US", {
    notation: "compact",
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 1,
  }).format(totalValue);

  const headerColor = findStageColor(status);

  return (
    <div className="flex-1 min-w-[200px] max-w-[280px]">
      {/* Column Header */}
      <div className={`rounded-t-lg px-3 py-2 ${headerColor}`}>
        <h3 className="text-sm font-semibold text-white">
          {findStageLabel(status)}
        </h3>
        <p className="text-xs text-white/80">
          {jobs.length} jobs · {formattedTotal}
        </p>
      </div>

      {/* Droppable Area */}
      <Droppable droppableId={status}>
        {(droppableProvided, snapshot) => (
          <div
            ref={droppableProvided.innerRef}
            {...droppableProvided.droppableProps}
            className={`flex flex-col gap-2 p-2 min-h-[200px] rounded-b-lg border border-t-0 border-gray-200 dark:border-gray-700 ${
              snapshot.isDraggingOver
                ? "bg-gray-50 dark:bg-gray-800"
                : "bg-gray-100/50 dark:bg-gray-900/50"
            }`}
          >
            {jobs.map((job, index) => (
              <JobCard key={job.id} job={job} index={index} />
            ))}
            {droppableProvided.placeholder}
          </div>
        )}
      </Droppable>
    </div>
  );
};
